<template>
  <ul class="list-group workflow-group" :id="'editorForm0'">
    <li class="list-group-item workflow-green" @click="show('trigger')">
      <strong>1단계 트리거</strong>
    </li>
    <div class="card workflow-content" v-show="showEditTrig">
      <div class="header"
           v-if="appCode == ''">
        트리거는 워크플로를 시작하는 이벤트입니다.
      </div>
      <div class="body">
        <div
          class="input-group search"
          v-if="appCode == ''"
        >
          <input type="text" class="form-control" v-model="keyword" placeholder="검색하기..." />
          <div class="input-group-append">
            <span class="input-group-text"  @click="totalApps"
            ><font-awesome-icon :icon="faSearch"/></span>
          </div>
        </div>
        <div
          v-if="appCode == ''"
          id="appListContainer"
          class="container row clearfix row-deck"
        >
          <div
            class="btn btn-neutral apps col-lg-3 col-md-6 col-sm-12 card"
            v-for="(app, index) in totalAppList"
            :key="index"
            @click="chooseApp(0, index)"
          >
            <strong v-if="app.appCode === 'APPS20220712133352482'"><img class="workIcon" src="@/assets/images/finallogo.png" />{{ app.appName }}</strong>
            <strong v-else-if="app.appCode === 'APPS20240825203742145'"><img class="workIcon" src="@/assets/images/smartup.jpg" />{{ app.appName }}</strong>
            <strong v-else-if="app.appCode === 'APPS20220610115258429'"><img class="workIcon" src="@/assets/images/alimcall.jpg" />{{ app.appName }}</strong>
            <strong v-else-if="app.appCode === 'APPS20220103175140644'"><img class="workIcon" src="@/assets/images/frientsIo.png" />{{ app.appName }}</strong>
            <strong v-else-if="app.appCode === 'APPS20220701131556689'"><img class="workIcon" src="@/assets/images/wishpond.png" />{{ app.appName }}</strong>
            <strong v-else><img class="workIcon" src="@/assets/noimage.png" />{{ app.appName }}</strong>
          </div>
        </div>

        <!-- 앱 선택 후 -->
        <div
          class="row clearfix"
          v-if="appCode != ''"
        >
          <div>
            <div
              class="header"
              v-if="choosedApp.appName != null"
            >
              {{ choosedApp.appName }}
            </div>
          </div>
          <div class="col-md-12 col-lg-12">
            <div
              class="panel-group"
              id="accordion_1"
              role="tablist"
              aria-multiselectable="true"
            >
              <div class="panel panel-primary card">
                <div class="panel-heading" role="tab" id="headingOne_1">
                  <h4 class="panel-title back-gray">
                    <a
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion_1"
                      href="#collapseOne_1"
                      aria-expanded="true"
                      aria-controls="collapseOne_1"
                      @click="show('CE', 0)"
                    >
                      앱 &amp; 이벤트 선택
                    </a>
                  </h4>
                </div>
                <div
                  id="collapseOne_1"
                  class="panel-collapse collapse in"
                  role="tabpanel"
                  aria-labelledby="headingOne_1"
                  :class="{ show: showCE }"
                >
                  <div class="panel-body">
                    <h2 class="card-inside-title">앱</h2>
                    <select
                      class="form-control show-tick"
                      v-model="appCode"
                      @change="chooseApp(0)"
                    >
                      <option value="">-- 선택 --</option>
                      <option
                        v-for="(app, index) in totalAppList"
                        :key="index"
                        :value="app.appCode"

                      >
                        {{ app.appName }}
                      </option>
                    </select>
                    <h2 class="card-inside-title">트리거 이벤트 </h2>

<!--                      @click="getApiList(0)"-->
<!--                      @change="getApiDetail(0)"-->
                    <select
                      class="form-control show-tick"
                      v-model="selectApi"

                    >
                      <option :value="undefined" disabled>-- 선택 --</option>
                      <option
                        v-for="api in triggerLists"
                        :key="api.apiCode"
                        :value="api.apiCode"
                      >
                        {{ api.apiName }} ( {{ api.versionCode }} )
                      </option>
                    </select>

                    <!-- 일단 주석 (삭제x)
                    <div class="help-info">
                      워크플로우를 시작시킬 이벤트
                    </div> -->

                    <button
                      type="button"
                      class="btn btn-primary btn-block btn-continue"
                      v-if="selectApi == '' || triggerLists.length == 0"
                      disabled
                    >
                      계속 진행하려면 앱을 선택해주세요.
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-block btn-continue"
                      v-if="selectApi != '' && triggerLists.length > 0"
                      @click="show('CA', 0), getAuthLists()"
                    >
                      계속 진행
                    </button>
                  </div>
                </div>
              </div>

              <div class="panel panel-primary card">
                <div class="panel-heading" role="tab" id="headingTwo_1">
                  <h4 class="panel-title back-gray">
                    <a
                      class="collapsed"
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion_1"
                      href="#collapseTwo_1"
                      aria-expanded="false"
                      aria-controls="collapseTwo_1"
                      @click="show('CA', 0)"
                    >
                      계정선택
                    </a>
                  </h4>
                </div>
                <div
                  id="collapseTwo_1"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingTwo_1"
                  :class="{ show: showCA }"
                >
                  <div class="panel-body">
                    <h2 class="card-inside-title">계정<small>추가 후 불러오기를 클릭해주세요</small></h2>
                    <div>
                      <div >
                        <button
                            type="button"
                            class="btn back-gray btn-continue"
                            style="float: right;margin-left: 5px;"
                            @click="getAuthLists()"
                        ><font-awesome-icon :icon="faRedo" :class="{'fa-spin' : reloadAuthTrig}"/> <span style="font-size: 12px;">불러오기</span>
                        </button>
                        <button
                            type="button"
                            class="btn back-gray btn-continue"
                            style="float: right;"
                            @click="getAuth(0)"
                        >추가</button>
                      </div>
                      <div>

<!--                        계정 셀렉트 박스   -->
                        <select
                            class="form-control show-tick"
                            v-model="selectAuth"
                            @change="selectingAuth(0)"

                        >
                          <option :value="null">-- 선택 --</option>
                          <option
                              v-for="(authList, count) in testAuthList"
                              :key="count"
                              :value="authList.connectionCode"
                          ># {{ count + 1}}번 (생성일 : {{authList.insertDt}})  </option>


                        </select>

                      </div>



<!--                              @click="showModal('auth', 'open')"-->




<!--                      <div-->
<!--                        v-if="-->
<!--                          workflowStore.workflowsS[0].api.test.response-->
<!--                            .source == ''-->
<!--                        "-->
<!--                      >-->
<!--                        <button-->
<!--                          type="button"-->
<!--                          class="btn back-gray btn-block btn-continue"-->
<!--                          @click="getAuth(0)"-->
<!--                        >-->
<!--                          <span-->
<!--                            v-for="app in workflowStore.apps"-->
<!--                            :key="app.appCode"-->
<!--                            ><span-->
<!--                              v-if="-->
<!--                                app.appCode ==-->
<!--                                workflowStore.workflowsS[0].api.appCode-->
<!--                              "-->
<!--                              >{{ app.appName }} 에 로그인 해주세요</span-->
<!--                            ></span-->
<!--                          >-->
<!--                        </button>-->
<!--                      </div>-->
<!--                      <div-->
<!--                        v-if="-->
<!--                          workflowStore.workflowsS[0].api.test.response-->
<!--                            .source != ''-->
<!--                        "-->
<!--                      >-->
<!--                        <select class="form-control show-tick" v-model="selecAcc">-->
<!--                        <option value="" disabled selected>-->
<!--                          계정을 선택해 주세요-->
<!--                        </option>-->
<!--                        <option-->
<!--                          v-for="tAccount in tAccounts"-->
<!--                          :key="tAccount.id"-->
<!--                          :value="tAccount.tAccount"-->
<!--                          @click="showModal('auth', 'open')"-->
<!--                        >-->
<!--                          {{ tAccount.tAccount }} (임시)-->
<!--                        </option>-->
<!--                      </select>-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--                      response :-->
<!--                      {{ workflowStore.workflowsS[0].api.test.response.source }}-->
<!--                      &lt;!&ndash; <select class="form-control show-tick" v-model="selecAcc">-->
<!--                        <option value="" disabled selected>-->
<!--                          계정을 선택해 주세요-->
<!--                        </option>-->
<!--                        <option-->
<!--                          v-for="tAccount in tAccounts"-->
<!--                          :key="tAccount.id"-->
<!--                          :value="tAccount.tAccount"-->
<!--                          @click="showModal('auth', 'open')"-->
<!--                        >-->
<!--                          {{ tAccount.tAccount }}-->
<!--                        </option>-->
<!--                      </select> &ndash;&gt;-->
<!--                    </div>-->
<!--                    <div v-else>-->
<!--                      type있음-->
<!--                      &lt;!&ndash; <select class="form-control show-tick" v-model="selecAcc">-->
<!--                        <option value="" disabled selected>-->
<!--                          계정을 선택해 주세요-->
<!--                        </option>-->
<!--                        <option-->
<!--                          v-for="tAccount in tAccounts"-->
<!--                          :key="tAccount.id"-->
<!--                          :value="tAccount.tAccount"-->
<!--                        >-->
<!--                          {{ tAccount.tAccount }}-->
<!--                        </option>-->
<!--                      </select> &ndash;&gt;-->
                    </div>

                    <button
                      type="button"
                      class="btn btn-primary btn-block btn-continue"
                      v-if="selectAuth == null"
                      disabled
                    >
                      계속 진행하려면 계정을 선택해주세요.
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-block btn-continue"
                      v-if="selectAuth != null"
                      @click="setTrigInputs(0)"
                    >
                      계속 진행
                    </button>
<!--                    <button-->
<!--                      type="button"-->
<!--                      class="btn btn-primary btn-block btn-continue"-->
<!--                      v-if="-->
<!--                        selectAuth != null &&-->
<!--                        apiSettingList.length <= 0-->
<!--                      "-->
<!--                      @click="show('TT'), updateWorkflow()"-->
<!--                    >-->
<!--                      계속 진행-->
<!--                    </button>-->
                  </div>
                </div>
              </div>
              <div
                class="panel panel-primary card"
                v-show="apiSettingList.length> 0"
              >
                <div class="panel-heading" role="tab" id="headingThree_1">
                  <h4 class="panel-title back-gray">
                    <a
                      class="collapsed"
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion_1"
                      href="#collapseThree_1"
                      aria-expanded="false"
                      aria-controls="collapseThree_1"
                      @click="show('ST', 0)"
                    >
                      트리거 설정
                    </a>
                  </h4>
                </div>
                <div
                  id="collapseThree_1"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingThree_1"
                  :class="{ show: showST }"
                >
                  <div class="panel-body">
                    <div
                      v-for="(form, index) in apiSettingList"
                      :key="index"
                    >
                      <div v-if="form.dropdown == 0 || form.dropdown == undefined">
                        <h2 class="card-inside-title">{{apiSettingList[index].label }} ({{apiSettingList[index].key }}) <small>{{ optionalOrNot(form.required) }}</small></h2>
                        <div v-if="form.multi == 0">
                          <input
                            type="text"
                            class="form-control"
                            :placeholder="form.label"
                            :name="form.key"
                            v-model="workflowStore.workflowsS[0].api.design.forms[index].value"
                          />
                        </div>
                        <div v-if="form.multi == 1">

                          <user-editor-multi-boxs v-bind:actionCount="0" v-bind:multiFormIndex="index" />
<!--                          <input-->
<!--                            type="text"-->
<!--                            class="form-control"-->
<!--                            :placeholder="form.label"-->
<!--                            :name="form.keys"-->
<!--                            v-model="tagVal"-->
<!--                            @keyup.enter="addMultiVal(0, index)"-->
<!--                          />-->
<!--                          <span-->
<!--                            v-for="(val, valI) in workflowStore.workflowsS[0].api.design.forms[index].value"-->
<!--                            :key="valI"-->
<!--                            class="tag badge badge-info"-->
<!--                            style="margin: 3px 5px 0px 0px; font-size: 14px;"-->
<!--                          >-->
<!--                            {{ val }}-->
<!--                            <span-->
<!--                              @click="removeMultiVal(0, index, valI)"-->
<!--                              style="margin: 0px 2px 0px 8px"-->
<!--                            >-->
<!--                              x-->
<!--                            </span>-->
<!--                          </span>-->
                        </div>
                      </div>
                      <div v-if="form.dropdown == 1">
                        <div v-if="form.dropdownSource.type == 'static'">
                          <user-editor-dropdown-type v-bind:formData="form" v-bind:actionCount="0" v-bind:dropdownIndex="index" />
<!--                          <h2 class="card-inside-title">{{apiSettingList[index].label }} ({{apiSettingList[index].key }})</h2>-->
<!--                          <select-->
<!--                            class="form-control show-tick"-->
<!--                            v-model="-->
<!--                              $store.state.workflowStore.workflowsS[0].api.design.forms[index].value-->
<!--                            "-->
<!--                          >-->
<!--                            <option value="" selected disabled>-->
<!--                              종류를 선택해주세요.-->
<!--                            </option>-->
<!--                            <option-->
<!--                              v-for="(coso, cosoI) in form.dropdownSource-->
<!--                                .codeSource"-->
<!--                              :key="cosoI"-->
<!--                              :value="coso"-->
<!--                            >-->
<!--                              {{ coso }}-->
<!--                            </option>-->
<!--                          </select>-->
                        </div>
                        <div v-if="form.dropdownSource.type == 'dynamic'">
<!--                          <div>dropdown source</div>-->

                          <user-editor-dropdown-source :key="catcheKey" v-bind:indexs="index" v-bind:actionCount="0" v-bind:authCount="selectAuth" v-bind:dropdownSource="apiSettingList[index]"/>

                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn btn-primary btn-block btn-continue"
                      @click=" checkIfNull()"
                    >
                      계속 진행
                    </button>
                  </div>
                </div>
              </div>
              <div class="panel panel-primary card">
                <div class="panel-heading" role="tab" id="headingFour_1">
                  <h4 class="panel-title back-gray">
                    <a
                      class="collapsed"
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion_1"
                      href="#collapseThree_1"
                      aria-expanded="false"
                      aria-controls="collapseThree_1"
                      @click="show('TT')"
                    >
                      트리거 테스트
                    </a>
                  </h4>
                </div>
                <div
                  id="collapseThree_2"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingThree_1"
                  :class="{ show: showTT }"
                >
                  <div class="panel-body">
                    <div style="text-align: center">
                      계정연결과 트리거 설정이 정상적으로 되어있는지 확인합니다.
                    </div>
                    <div  v-if="textIfNotArray" style="text-align: center">Array 타입이 아닙니다.</div>
                    <div>
                      <div v-if="testResult.length > 0">
                        <div class="form-group">
                          <div class="form-line">
                            <textarea rows="10" class="form-control no-resize" v-model="testResult">
                            </textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="text-align: center">

                      <button
                        type="button"
                        class="btn btn-primary  btn-continue"
                        :disabled = "testResult != ''"
                        @click="triggerTest()"
                      >
                        테스트하기
                      </button>
                      &nbsp;
                      &nbsp;
                      <button
                        type="button"
                        class="btn btn-primary  btn-continue"
                        @click="saveTrigger()"
                      >
                        저장하기
                      </button>




                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ul>
</template>

<script>
import eventbus from "@/store/modules/devEventBus";

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import {faRedo} from "@fortawesome/free-solid-svg-icons";

import UserEditorMultiBoxs from "@/views/user/editor/UserEditorMultiBoxs";
import UserEditorDropdownSource from "@/views/user/editor/UserEditorDropdownSource";
import UserEditorDropdownType from "@/views/user/editor/UserEditorDropdownType";

export default {
  name: "UserEditorTrigger",
  components: {
    UserEditorDropdownSource,
    UserEditorDropdownType,
    FontAwesomeIcon,
    UserEditorMultiBoxs
  },
  data() {
    return {
      appCode : null,
      totalAppList : null,

      selectApi : '',
      selectAuth : null,
      apiCode : "",
      testAuthList : null,
      authForms : [],
      apiList : [],
      triggerLists : [],
      apiSettingList : [],
      keyword : "",
      apiDetail: [],
      testResult: "",


      showEditTrig: true,
      showCE: true,
      showCA: false,
      showST: false,
      showTT: false,
      choosedApp: null,

      faSearch,
      faRedo,
      reloadAuthTrig : false,
      textIfNotArray : false,

      catcheKey : 0,
    };
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    userStore() {
      return this.$store.state.userStore;
    },
  },

  methods: {
    checkIfNull(){

      var workflowForm = this.$store.state.workflowStore.workflowsS
      var forms = workflowForm[0].api.design.forms

      for(var i = 0; i < forms.length; i++){
      console.log("ㅇㅇㅇㅇ---", forms[i].value, forms[i].required)

        if(forms[i].required == 1 && (forms[i].value == "" || forms[i].value == undefined)){
          alert("필수 사항을 입력해주세요.")
          return;
        }


      }

      this.textIfNotArray = false;




      this.show('TT')

    this.updateWorkflow()
    },

    optionalOrNot(val){
      if(val == 0){
        return "선택"
      } else {
        return "필수"
      }
    },
    show(step, i) {
      this.testResult = ""

      console.log("ㄴshow 하는 중", i)

      if (step == "CE") {
        this.showCE = !this.showCE;
      }
      if (step == "CA") {
        if (this.selectApi == "") {
          this.showCA = false;
        } else {
          this.showCA = true;
          this.showST = false;
          this.showTT = false;
        }
      }
      if (step == "ST" && this.selectAuth != null) {
        this.showST = true;
      }
      if (step == "TT" && this.selectAuth != null) {
        // this.testResult = ""
        this.showTT = !this.showTT;
      }
      if (step == "trigger") {
        this.showEditTrig = !this.showEditTrig;
      }
    },
    totalApps() {

      this.totalAppList = []

      var param = { userCode: this.$store.state.userStore.userCode, keyword : this.keyword };

      this.api.appWorkflowList(param)
      .then((res)=>{
        console.log(res)

        if(this.utils.preApiHandle(res)) {
          console.log("dev create page res : ", res)
        }

        this.totalAppList = res.app

      })
    },
    // getImagePath(value){
    //
    //   if(value != undefined){
    //     return "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/" + value;
    //
    //   } else {
    //     return "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/common/noimage.jpg"
    //
    //   }
    //
    // },
    cacheKeyReRender(){
      this.catcheKey += 1;
    },
    setTrigInputs(index){

      this.cacheKeyReRender();



      var testObj = [];
      var topObj = [];

      testObj.push({'name': '테스트를 진행해주세요', disabled:true})

      topObj.push({'name' : '폴더', 'list':testObj})
      this.$store.state.userStore.testData = topObj


      console.log("ㅇㅇㅇ",this.selectApi)
      //selectApi[0]



      var workflowForm = this.$store.state.workflowStore.workflowsS
      console.log("ㅇㅇㅇ",workflowForm)
      // workflowForm[index].api.design.forms = []
      var sublist = []


      for(var i = 0; i < this.triggerLists.length; i++){
        console.log(this.triggerLists[i].apiCode)
        if(this.triggerLists[i].apiCode == this.selectApi){
          console.log("json :",JSON.parse(this.triggerLists[i].apiSchema).design.forms)


          this.apiDetail = this.triggerLists[i]
          workflowForm[index].api.apiCode = this.apiDetail.apiCode
          workflowForm[index].api.apiName = this.apiDetail.apiName
          workflowForm[index].api.apiKey = this.apiDetail.apiKey
          workflowForm[index].api.apiType = this.apiDetail.apiType
          workflowForm[index].api.versionCode = this.apiDetail.versionCode
          workflowForm[index].api.design = JSON.parse(this.apiDetail.apiSchema).design
          workflowForm[index].api.configure = JSON.parse(this.apiDetail.apiSchema).configure
          workflowForm[index].api.test = JSON.parse(this.apiDetail.apiSchema).test
          workflowForm[index].api.define = JSON.parse(this.apiDetail.apiSchema).define



          if(JSON.parse(this.triggerLists[i].apiSchema).design.forms != undefined){


              for(var j = 0; j < JSON.parse(this.triggerLists[i].apiSchema).design.forms.length; j++){
                sublist.push({
                  key: JSON.parse(this.triggerLists[i].apiSchema).design.forms[j].keys ,
                  label: JSON.parse(this.triggerLists[i].apiSchema).design.forms[j].label,
                  dropdown: JSON.parse(this.triggerLists[i].apiSchema).design.forms[j].dropdown,
                  multi: JSON.parse(this.triggerLists[i].apiSchema).design.forms[j].multi,
                  required: JSON.parse(this.triggerLists[i].apiSchema).design.forms[j].required,
                  dynamic: JSON.parse(this.triggerLists[i].apiSchema).design.forms[j].dynamic,
                  dropdownSource: JSON.parse(this.triggerLists[i].apiSchema).design.forms[j].dropdownSource,
                  value:"",
                  multibox: ""


                })


              }
          }

        }

      }

      console.log("sublist:",sublist )
      this.apiSettingList = sublist


      if(this.apiSettingList.length > 0){
        this.show('ST')
      } else {

        this.show('TT')
      }



      //  dropdownSource \ 으로 표시되는 내용 수정해서 다시 담는 부분
      for(var ss = 0; ss < workflowForm[index].api.design.forms.length; ss++) {
        if(workflowForm[index].api.design.forms[ss].dropdown == 1 && workflowForm[index].api.design.forms[ss].dropdownSource.codeSource != undefined) {
          workflowForm[index].api.design.forms[ss].dropdownSource.codeSource = JSON.parse(workflowForm[index].api.design.forms[ss].dropdownSource.codeSource)
        }
      }





      console.log("workflowForm:",workflowForm )
      this.$store.dispatch("saveWorkflowForm", workflowForm)
      .then(()=>{
        this.updateWorkflow()

      })


    },

    selectingAuth(i){

      var workflowForm = this.$store.state.workflowStore.workflowsS;
      // workflowForm[i].authentication.index = this.selectAuth;
      workflowForm[i].authentication.connectionCode = this.selectAuth;
      // workflowForm[i].authentication.content = this.selectAuth;

      console.log("여여여여여여여 ",workflowForm[i])

      // this.$store.dispatch("saveWorkflowForm", workflowForm);
      // this.updateWorkflow();

    },
    getApiList() {
      this.triggerLists = []

      console.log("sfdsffdf" , this.choosedApp)

      var param = { appCode: this.choosedApp.appCode, versionCode: this.choosedApp.versionCode };



      console.log(param )

      this.api.selectApi(param)
      .then((res)=>{

        console.log("결과1",res)



        // this.apiList = res.api
        var list = []
        // var subList = []

        for(var j = 0; j < res.api.length; j++){
          if(res.api[j].apiType == "trigger") {
            var visible = JSON.parse(res.api[j].apiSchema).visible

            console.log("visible : ", visible)


            if(visible == 'Y' ){
              list.push(res.api[j])

            }


            // subList.push({key:res.api[j].apiKey, label:res.api[j].apiName, value:""})

          }
        }

        this.triggerLists = list


      })


      // const res = await this.$store.dispatch("getApiList", {
      //   paths: Apiroot.userApi + Urls.getApiList,
      //   params: param,
      // });

      // this.$store.dispatch("saveApis", res.triggers);
    },
    getAuth(i) {
      const code = this.choosedApp.appCode;
      const ver = this.choosedApp.versionCode;

      var param = { appCode: code, versionCode: ver };


      this.api.getApiList(param)
          .then((res) => {

        console.log("get:", res, i)

        //모달 안뜸 확인 해야 함 ~~~~~~

        // const workflows = this.workflowStore.workflowsS;
        // workflows[i].api.test = {};
        // workflows[i].api.test = JSON.parse(
        //     JSON.stringify(this.workflowStore.testS)
        // );

        // const forms = JSON.parse(res.apis[0].apiSchema).design.forms;

        //인증 관련 api 고르기

        // if(forms != undefined){
          for(var j = 0; j < res.apis.length; j++){

            // console.log(res.apis[j])

            if(res.apis[j].apiType == "authentication"){
              this.$store.state.devStore.apiAuth[0] = res.apis[j]
              this.$store.state.devStore.apiData = res.apis[j]

            }
          }
          console.log("클릭")

            // this.$store.state.devStore.userAuthModal = true;

          this.api.selectOneApi({apiCode : this.$store.state.devStore.apiData.apiCode})
              .then((res)=>{

                console.log("모달 띄우기 전 :",res)

                var formform = [];

                var today = new Date();
                var year = today.getFullYear();
                var month = ("0" + (1 + today.getMonth())).slice(-2);
                var day = ("0" + today.getDate()).slice(-2);

                var insertDt =  year + "-" + month + "-" + day;

                  for(var i = 0;  i < JSON.parse(res.api.apiSchema).design.forms.length; i++){
                    var list = new Object;



                    list = {
                      key: JSON.parse(res.api.apiSchema).design.forms[i].keys.replace(
                          /"/gi,
                          ""
                      ),
                      label: "{{bundle.authData." + JSON.parse(res.api.apiSchema).design.forms[i].keys.replace(/"/gi, "") + "}}",
                      value: "",
                      insertDt: insertDt,
                      index: i + 1,
                    };


                    formform.push(list);








                }


                  console.log("모달 띄우기 전:", formform)


                this.$store.state.workflowStore.modalInput = formform;




              })




          this.$store.dispatch("setAuthModal", {
            params : 0,
              status : true

            });


            eventbus.$emit("openAuthModal", 0);

          // this.$store.dispatch("getUserAuthModal", {state : 0})


          // eventbus.$emit("openAuthModal", 0)


        // forms.workflowIndex = i;
        // for (var j = 0; j < forms.length; j++) {
        //   // workflows[i].api.test.request.params.push({
        //   //   name: forms[j].label,
        //   //   value: "",
        //   // });
        // }

        // const modalParam = {
        //   workflowIndex: i,
        //   forms: forms,
        //   apiSchema: JSON.parse(res.apis[0].apiSchema),
        // };
        //
        // this.showModal("auth", "open", modalParam);

      })

      eventbus.$emit("openAuthModal", 0);



    },

    chooseApp(i, index) {

      //모든값 리셋


      this.authForms = []
      // this.choosedApp = null;
      this.selectApi = null;
      this.apiSettingList = []
      this.selectAuth = null
      this.testAuthList = null

      this.testResult = ""
      this.$store.state.userStore.testData = [];


      console.log("리 ㅛ셋 ", this.choosedApp, this.appCode)

      this.showCA = false
      this.showST = false
      this.showTT = false

      console.log(index)




      // this.appCode = this.totalAppList[index].appCode

      // this.$store.state.workflowStore.workflowsS[0].api.appCode = this.totalAppList[index].appCode

      if(index == undefined){
        var coode = this.appCode
        console.log(coode)

        for(var o = 0; o < this.totalAppList.length; o++){
          if(coode == this.totalAppList[o].appCode){
            this.choosedApp = this.totalAppList[o]
            this.appCode = this.totalAppList[o].appCode

          }
        }



      } else {

        this.choosedApp = this.totalAppList[index]
        this.appCode = this.totalAppList[index].appCode
      }


      console.log(this.choosedApp)




      var workflowForm = this.$store.state.workflowStore.workflowsS
      workflowForm[0].api = this.choosedApp


      // this.$store.dispatch("saveWorkflowForm", workflowForm);

      // this.updateWorkflow()


      // const code = app.appCode;

      // workflow에 appCode 저장
      // const workflows = this.workflowStore.workflowsS;
      // workflows[i].api.appCode = code;
      // workflows[i].api.versionCode = app.versionCode;


      // this.$store.dispatch("buildWorkflows", workflows);

      console.log("ㄹ;ㅅ,ㅌ[ ")

      // api리스트 불러오기
      this.getApiList();
    },
    async updateWorkflow() {
      var param = {
        workflowCode: this.$store.state.workflowStore.workflowCode,
        workflowName: this.$store.state.workflowStore.workflowName,
        groupCode: this.$store.state.workflowStore.groupCode,
        insertDt: "",
        workflows: JSON.stringify(this.$store.state.workflowStore.workflowsS),
      }


      console.log("param " , param)

      const res = await this.api.updateWorkflow(param);
      console.log("updateWorkflow res : ", res)

      return res;
    },

    showModal(tag, status, param) {
      this.$store.dispatch("showModal", {
        params: param,
        tag: tag,
        status: status,
      });

      document.getElementsByClassName("overlay")[0].style.display = "block";
    },
    //

    getAuthLists(){

      this.$store.state.workflowStore.workflowsS[0].api.apiCode =  this.selectApi

      this.reloadAuthTrig = true;

      console.log("api auth ")


      var list = [];

      var param = {
        userCode : this.$store.state.userStore.userCode,
        appCode : this.$store.state.workflowStore.workflowsS[0].api.appCode,
        versionCode : this.$store.state.workflowStore.workflowsS[0].api.versionCode
      };

      console.log(param)

      this.api.getConnectionList(param)
      .then((res)=>{

        console.log(res)

        const connections = res.connections;
        console.log("connections : ", connections);

        if (connections != null) {
          for (var i = 0; i < connections.length; i++) {
            // console.log(api[i]);
          //   if (api[i].apiType != "trigger" && api[i].apiType != "action") {
          //
          //     console.log("인증:",JSON.parse(api[i].apiSchema).test.request.authentication)
          //     console.log(JSON.parse(api[i].apiSchema).design.forms)
          //     this.authForms.push(JSON.parse(api[i].apiSchema).design.forms)
          //
          //   var obj = {
          //     connectionCode : connections[i].connectionCode,
          //     apiKey : connections[i].apiKey,
          //     connectionName : connections[i].connectionName,
          //     insertDt : connections[i].insertDt,
          //     workflowCode : connections[i].workflowCode,
          //
          //
          //   }


              list.push({
                connectionCode : connections[i].connectionCode,
                apiKey : connections[i].apiKey,
                connectionName : connections[i].connectionName,
                insertDt : connections[i].insertDt,
                workflowCode : connections[i].workflowCode
              });
          //
              if(this.$store.state.workflowStore.workflowsS[0].authentication.connectionCode != null){
                if(this.$store.state.workflowStore.workflowsS[0].authentication.connectionCode == connections[i].connectionCode){
                  this.selectAuth = connections[i].connectionCode
                }
                // this.saveAuth(list);
              }
          //
          //
          //   }
          }
        }
        console.log("list:", list)
        this.reloadAuthTrig = false;

        this.testAuthList = list;
      })
    },

    saveAuth(list){
      console.log(this.$store.state.workflowStore.workflowsS[0].authentication.content)
      for(var i = 0; i < list.length; i++){

        // if(this.$store.state.workflowStore.workflowsS[this.actionCount].authentication.content[i][0].value == list[i][0].value){
        //   console.log("아! ")
        // }
        //값을 다 비교해서 모두 같으면 해당걸로 선택 하기
        console.log("ddd",(list[i].length))
        console.log("vvv",this.$store.state.workflowStore.workflowsS[0].authentication)

        // for(var j = 0; j < list[i].length; j++){
        //   console.log(list[i][j])
          // console.log(JSON.stringify(Object.values(this.$store.state.workflowStore.workflowsS[0].authentication.content[j])))

          if(list[i].connectionCode == JSON.stringify(Object.values(this.$store.state.workflowStore.workflowsS[0].authentication.connectionCode))){
            this.selectAuth = i

          // }

          // console.log(Object.values(list[i][j]))
          //
          // console.log(Object.values(this.$store.state.workflowStore.workflowsS[0].authentication.content[j]))
          //   if(this.$store.state.workflowStore.workflowsS[this.actionCount].authentication[0][j] == list[i][j]){
          //     console.log("ddddd")
          //   }
        }






      }



    },

    async saveTrigger() {
      const res = await this.updateWorkflow();

      if(res.code == 0) {
        console.log("trigger 저장 완료");
      }
    },

    triggerTest(val) {
      console.log("테스트 진입----------------")

      var param = {
        appCode: this.choosedApp.appCode,
        apiCode: this.selectApi,
        versionCode: this.choosedApp.versionCode,
        // paramData: JSON.stringify(this.testAuthList[this.selectAuth]),
        // authIndex : this.selectAuth,
        workflowCode : this.$store.state.workflowStore.workflowCode,
        workIndex : 0

      }

      console.log("전송 데이터:",param)
      console.log(this.choosedApp)
      // console.log(this.testAuthList[4])

      this.api.workflowApi(param).then((res) => {
        console.log("connectApi res : ", res)

        if(res.code != 0){
          this.testResult = "오류가 발생했습니다."
          return;
        }



        //array 마지막 1개만 출력해서 store. testData 쪽에 넣어두기
        if(typeof JSON.parse(res.result) === 'object'){

          var datas = JSON.parse(res.result)

          if(!Array.isArray(datas)){

            var bigKey = Object.keys(datas);
            console.log("big key:", bigKey)
            console.log("big key:", datas)
            for(var i = 0; i < bigKey.length; i++){
              var subDatas = datas[bigKey[i]]
              if(Array.isArray(subDatas)){

                console.log(subDatas)
                datas = subDatas
                break;
              }

            }


          }


          if(Array.isArray(datas )){

            this.textIfNotArray = false;
            // datas = JSON.stringify(datas, null, 4)
            console.log("길이 :", datas);


            if(datas.length > 0){

              this.testResult = JSON.stringify(datas[datas.length-1], null, 4);

              console.log("this.$store.state.userStore.testData[0]:" , this.$store.state.userStore.testData.length)




              // var testObj = [];
              // var topObj = [];
              //
              // testObj.push({'name': '테스트를 진행해주세요', disabled:true})
              //
              // topObj.push({'name' : '폴더', 'list':testObj})





              if(this.$store.state.userStore.testData.length == 0){
                this.$store.state.userStore.testData.push({key : this.$store.state.workflowStore.workflowsS[0].api.apiName, value : datas[datas.length-1]})

              } else {
                this.$store.state.userStore.testData[0] = {key : this.$store.state.workflowStore.workflowsS[0].api.apiName, value : datas[datas.length-1]}
              }


            } else {

              this.testResult = JSON.stringify(this.$store.state.workflowStore.workflowsS[0].api.define.source, null, 4)

              if(this.$store.state.userStore.testData.length== 0){
                this.$store.state.userStore.testData.push({key : this.$store.state.workflowStore.workflowsS[0].api.apiName, value : this.$store.state.workflowStore.workflowsS[0].api.define.source})

              } else {
                this.$store.state.userStore.testData[0] = {key : this.$store.state.workflowStore.workflowsS[0].api.apiName, value : this.$store.state.workflowStore.workflowsS[0].api.define.source}
              }


            }


          } else {
            this.textIfNotArray = true;
            this.testResult = JSON.stringify(datas, null, 4);
          }



        }

        if(val == null){
          this.saveTrigger()

        }


      });

    },

    addMultiVal(i, formI) {
      var valArr = [];
      var workflowForm = this.$store.state.workflowStore.workflowsS;


      if(workflowForm[i].api.design.forms[formI].value[0] == undefined) {
        valArr.push(this.tagVal);
        workflowForm[i].api.design.forms[formI].value = valArr;
      } else {
        workflowForm[i].api.design.forms[formI].value.push(this.tagVal);
      }

      this.tagVal = '';
      this.$store.dispatch("saveWorkflowForm", workflowForm);
      this.updateWorkflow();
    },

    removeMultiVal(i, formI, valI) {
      var workflowForm = this.$store.state.workflowStore.workflowsS;


      workflowForm[i].api.design.forms[formI].value.splice(valI, 1);


      this.$store.dispatch("saveWorkflowForm", workflowForm);
      this.updateWorkflow();
    },



  },
  created() {



    console.log("워크플로우우우우 :", this.$store.state.workflowStore)
    console.log("워크플로우우우우 :", this.workflowStore)

    eventbus.$once("resetApiDetail0" ,()=>{

      this.getAuthLists()

    })


    console.log("choiooos",this.choosedApp)
    console.log("choiooos",this.$store.state.workflowStore.workflowsS[0])

    this.totalApps();

    this.triggerLists = []
    this.apiSettingList = []


    //수정 시... 데이터 있을때
    if(this.$store.state.workflowStore.workflowCode != null){
      // this.$store.state.workflowStore.workflow.workflowCode = this.$store.state.workflowStore.workflowCode

      this.choosedApp = this.$store.state.workflowStore.workflowsS[0].api
      this.appCode = this.choosedApp.appCode
      this.getApiList();



      this.selectApi = this.$store.state.workflowStore.workflowsS[0].api.apiCode
      this.showCA = true;

      this.getAuthLists();
      console.log("폼 :", this.$store.state.workflowStore.workflowsS[0].api.design.forms.length)

      if(this.$store.state.workflowStore.workflowsS[0].api.design.forms.length > 0){
        this.showST = true
        // this.setTrigInputs();

        this.apiSettingList = this.$store.state.workflowStore.workflowsS[0].api.design.forms
        console.log("폼 :", this.apiSettingList)

      }

        this.showTT = true

      this.triggerTest("save")


    }



    // this.getAuthLists();

  },
  beforeDestroy() {
    this.$store.state.workflowStore.workflowsS = null
  }
};
</script>

<style scoped></style>
